import { useState, useRef } from 'react'

export const useSteps = ({
  initialStep,
  disableBackToFirstStep,
}: {
  initialStep?: number
  disableBackToFirstStep?: boolean
}) => {
  const [currentStep, setCurrentStep] = useState(() => initialStep || 1)
  const stepsSequence = useRef<number[]>([])

  const setStep = (step: number) => {
    if (!disableBackToFirstStep) {
      // if going to first step is not disabled - push current step to stepsSequence
      stepsSequence.current.push(currentStep)
      setCurrentStep(step)
    } else if (step > 1) {
      // if going to first step is disabled - push current step to stepsSequence only if it's not first step
      stepsSequence.current.push(currentStep)
      setCurrentStep(step)
    }
  }

  const isBackDisabled = stepsSequence.current.length === 0

  const onBack = () => {
    // in case user started wizard from the middle - let him go back to the first step and start process over
    if (!isBackDisabled) {
      setCurrentStep(initialStep || 1)
    }

    const lastStep = stepsSequence.current.pop()
    if (lastStep) {
      setCurrentStep(lastStep)
    }
  }

  return { setStep, onBack, currentStep, setCurrentStep, isBackDisabled }
}
